module.exports = __webpack_public_path__ + "static/img/vuex.6329c32.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/vuex.jpg
// module id = IGr8
// module chunks = 1